import { render, staticRenderFns } from "./EscrowAccount.vue?vue&type=template&id=81a0d5b8&scoped=true&"
import script from "./EscrowAccount.vue?vue&type=script&lang=js&"
export * from "./EscrowAccount.vue?vue&type=script&lang=js&"
import style0 from "./EscrowAccount.vue?vue&type=style&index=0&id=81a0d5b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a0d5b8",
  null
  
)

export default component.exports